// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"aff657dc","453":"bb12564a","667":"b444690c","977":"aa98671e"}[chunkId] + ".chunk.js";
};